import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'

class HadLessonTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    classInfo: PropTypes.object.isRequired
  }

  render(){
    let {classInfo} = this.props
    let {has_lesson} = classInfo

    return(
      <div className='class-has-lesson'>
        {has_lesson == true ? __('Scheduled', 'class') : __('Not Scheduled', 'class')}
      </div>
    )
  }
}


export default HadLessonTd



// WEBPACK FOOTER //
// ./src/containers/pages/Class/ClassTable/HadLessonTd.js